import { IFieldNameToFormField } from '../../../interfaces/iform-field-component';
export class FieldNameHashes {
    public hshColNameToFormField: IFieldNameToFormField = null;
    public hshDisplayVariableNameToFormField: IFieldNameToFormField = null;
    public hshFieldIdToFieldName = {};
}
